import React, { useMemo } from "react";

import { AxisText } from "./Axis/Text";
import { DreiLine } from "./Axis/Line";
import { textFormatFromZoomLevel } from "./utils";
import { formatTimeYear, CHART_DIMENSIONS, LAYOUT } from "../../utils";

export const XAxis = ({
  fontSize = LAYOUT.TIMELINE.AXIS.VERTICAL.FONT_SIZE * 0.75,
  opacity = 1,
  textFmt = formatTimeYear,
  textRotation = [0, 0, 0],
  textVisible = true,
  transitionConfig = {},
  xFunc = () => 1,
  years = [],
}) => {
  return (
    <>
      {years.map((year, idx) => (
        <React.Fragment key={`xaxis-container-${idx}`}>
          <DreiLine
            points={[
              [
                xFunc(year),
                CHART_DIMENSIONS.Y.MIN +
                  LAYOUT.TIMELINE.EVENTS.CONTEXTUAL.OFFSET,
                CHART_DIMENSIONS.Z.MIN,
              ],
              [
                xFunc(year),
                CHART_DIMENSIONS.Y.MIN +
                  LAYOUT.TIMELINE.EVENTS.CONTEXTUAL.OFFSET,
                CHART_DIMENSIONS.Z.MAX,
              ],
            ]}
            delay={transitionConfig.grid.delay(
              xFunc(year),
              CHART_DIMENSIONS.Y.MIN + LAYOUT.TIMELINE.EVENTS.CONTEXTUAL.OFFSET,
              CHART_DIMENSIONS.Z.MIN
            )}
            linewidth={1}
            width={1}
            opacity={idx % 2 === 0 ? opacity : opacity / 2}
            color={0xffffff}
            key={`x-axis-year-idx-${idx}`}
          />
          <AxisText
            key={`x-axis-year-${textFmt(year)}`}
            x={xFunc(year)}
            y={
              CHART_DIMENSIONS.Y.MIN + LAYOUT.TIMELINE.EVENTS.CONTEXTUAL.OFFSET
            }
            z={CHART_DIMENSIONS.Z.MAX + 2.5}
            rotation={textRotation}
            color={`rgb(255, 255, 255)`}
            visible={textVisible}
            font={"assets/fonts/GT-Zirkon-Regular.woff"}
            anchorX={"center"}
            depthTest={true}
            fontSize={fontSize}
            text={textFmt(year)}
          />
        </React.Fragment>
      ))}
    </>
  );
};

export const OrthographicXAxis = ({
  maxFontSize = LAYOUT.TIMELINE.AXIS.VERTICAL.FONT_SIZE * 0.75,
  // textFmt = formatTimeYear,
  textRotation = [0, 0, 0],
  textVisible = true,
  xFunc = () => 1,
  yPosition = CHART_DIMENSIONS.Y.MIN +
    2 * LAYOUT.TIMELINE.EVENTS.CONTEXTUAL.OFFSET,
  // texts = [],
  zoomLevel = 1,
}) => {
  const { labels, fontSize } = useMemo(() => {
    const { quantize, format, fontSize, dy } =
      textFormatFromZoomLevel(zoomLevel);
    const labels = xFunc.ticks(quantize.every(1)).map((d) => ({
      x: xFunc(d) * zoomLevel,
      y: yPosition + dy,
      z: 0,
      text: format(d),
    }));
    return { labels, fontSize };
  }, [yPosition, xFunc, zoomLevel]);

  return labels.map(({ x, y, text, z }) => (
    <AxisText
      key={`x-axis-year-${text}`}
      x={x}
      y={y}
      z={z}
      rotation={textRotation}
      color={`rgb(255, 255, 255)`}
      visible={textVisible}
      font={"assets/fonts/GT-Zirkon-Regular.woff"}
      anchorX={"center"}
      depthTest={true}
      fontSize={fontSize}
      text={text}
    />
  ));
};
